import { useProfileData } from '../AuthProvider'
import * as style from './style.module.scss'
import Link from 'gatsby-link'
import * as React from 'react'

const Logo = ({ linked = true }) => {
  const profile = useProfileData({ optional: true })
  const destination = profile ? '/dashboard' : '/'
  const content = (
    <>
      <span aria-label='ball' className={style.dot} />
      doggos
    </>
  )

  if (!linked) {
    return <span className={style.logo}>{content}</span>
  }

  return (
    <Link to={destination} className={style.logo}>
      {content}
    </Link>
  )
}

export default Logo
